'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var once = exports.once = function once(func) {
  var count = 0;

  return function () {
    if (count === 0) {
      count = 1;
      func.apply(undefined, arguments);
    }
  };
};